<template>
  <div class="hero-bg-gradient absolute w-full h-full z-0">
    <div class="spot-1" />
    <div class="spot-2" />
    <div class="spot-3" />
    <div class="big-circle" />
  </div>
</template>
